(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4209],{

/***/ 36111:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
}), 'Favorite');
exports.Z = _default;

/***/ }),

/***/ 91811:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
}), 'FavoriteBorder');
exports.Z = _default;

/***/ }),

/***/ 12963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 4 modules
var useSlotProps = __webpack_require__(56504);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/MoreHoriz.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/BreadcrumbCollapsed.js


const _excluded = ["slots", "slotProps"];







const BreadcrumbCollapsedButton = (0,styled/* default */.ZP)(ButtonBase/* default */.Z)(({
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`
}, theme.palette.mode === 'light' ? {
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700]
} : {
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.grey[100]
}, {
  borderRadius: 2,
  '&:hover, &:focus': (0,esm_extends/* default */.Z)({}, theme.palette.mode === 'light' ? {
    backgroundColor: theme.palette.grey[200]
  } : {
    backgroundColor: theme.palette.grey[600]
  }),
  '&:active': (0,esm_extends/* default */.Z)({
    boxShadow: theme.shadows[0]
  }, theme.palette.mode === 'light' ? {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
  } : {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[600], 0.12)
  })
}));
const BreadcrumbCollapsedIcon = (0,styled/* default */.ZP)(MoreHoriz)({
  width: 24,
  height: 16
});

/**
 * @ignore - internal component.
 */
function BreadcrumbCollapsed(props) {
  const {
      slots = {},
      slotProps = {}
    } = props,
    otherProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = props;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedButton, (0,esm_extends/* default */.Z)({
      focusRipple: true
    }, otherProps, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedIcon, (0,esm_extends/* default */.Z)({
        as: slots.CollapsedIcon,
        ownerState: ownerState
      }, slotProps.collapsedIcon))
    }))
  });
}
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = (BreadcrumbCollapsed);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/breadcrumbsClasses.js


function getBreadcrumbsUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = (0,generateUtilityClasses/* default */.Z)('MuiBreadcrumbs', ['root', 'ol', 'li', 'separator']);
/* harmony default export */ var Breadcrumbs_breadcrumbsClasses = (breadcrumbsClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js


const Breadcrumbs_excluded = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];












const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    li: ['li'],
    ol: ['ol'],
    separator: ['separator']
  };
  return (0,composeClasses/* default */.Z)(slots, getBreadcrumbsUtilityClass, classes);
};
const BreadcrumbsRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiBreadcrumbs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [{
      [`& .${Breadcrumbs_breadcrumbsClasses.li}`]: styles.li
    }, styles.root];
  }
})({});
const BreadcrumbsOl = (0,styled/* default */.ZP)('ol', {
  name: 'MuiBreadcrumbs',
  slot: 'Ol',
  overridesResolver: (props, styles) => styles.ol
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
const BreadcrumbsSeparator = (0,styled/* default */.ZP)('li', {
  name: 'MuiBreadcrumbs',
  slot: 'Separator',
  overridesResolver: (props, styles) => styles.separator
})({
  display: 'flex',
  userSelect: 'none',
  marginLeft: 8,
  marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        children: separator
      }, `separator-${index}`));
    } else {
      acc.push(current);
    }
    return acc;
  }, []);
}
const Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBreadcrumbs'
  });
  const {
      children,
      className,
      component = 'nav',
      slots = {},
      slotProps = {},
      expandText = 'Show path',
      itemsAfterCollapse = 1,
      itemsBeforeCollapse = 1,
      maxItems = 8,
      separator = '/'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Breadcrumbs_excluded);
  const [expanded, setExpanded] = react.useState(false);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  });
  const classes = useUtilityClasses(ownerState);
  const collapsedIconSlotProps = (0,useSlotProps/* default */.Z)({
    elementType: slots.CollapsedIcon,
    externalSlotProps: slotProps.collapsedIcon,
    ownerState
  });
  const listRef = react.useRef(null);
  const renderItemsBeforeAndAfter = allItems => {
    const handleClickExpand = () => {
      setExpanded(true);

      // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.
      // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
      // By moving it to some link/button at least we have some announcement.
      const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
      if (focusable) {
        focusable.focus();
      }
    };

    // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem
    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}
      return allItems;
    }
    return [...allItems.slice(0, itemsBeforeCollapse), /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      slots: {
        CollapsedIcon: slots.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: collapsedIconSlotProps
      },
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)];
  };
  const allItems = react.Children.toArray(children).filter(child => {
    if (false) {}
    return /*#__PURE__*/react.isValidElement(child);
  }).map((child, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: classes.li,
    children: child
  }, `child-${index}`));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: component,
    color: "text.secondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState: ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

/***/ }),

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 44267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js


function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js


const _excluded = ["className", "component"];








const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};
const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 83965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardMedia_CardMedia; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardMedia/cardMediaClasses.js


function getCardMediaUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardMedia', slot);
}
const cardMediaClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardMedia', ['root', 'media', 'img']);
/* harmony default export */ var CardMedia_cardMediaClasses = ((/* unused pure expression or super */ null && (cardMediaClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardMedia/CardMedia.js


const _excluded = ["children", "className", "component", "image", "src", "style"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    isMediaComponent,
    isImageComponent
  } = ownerState;
  const slots = {
    root: ['root', isMediaComponent && 'media', isImageComponent && 'img']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardMediaUtilityClass, classes);
};
const CardMediaRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardMedia',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      isMediaComponent,
      isImageComponent
    } = ownerState;
    return [styles.root, isMediaComponent && styles.media, isImageComponent && styles.img];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'block',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
}, ownerState.isMediaComponent && {
  width: '100%'
}, ownerState.isImageComponent && {
  // ⚠️ object-fit is not supported by IE11.
  objectFit: 'cover'
}));
const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
const IMAGE_COMPONENTS = ['picture', 'img'];
const CardMedia = /*#__PURE__*/react.forwardRef(function CardMedia(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardMedia'
  });
  const {
      children,
      className,
      component = 'div',
      image,
      src,
      style
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const isMediaComponent = MEDIA_COMPONENTS.indexOf(component) !== -1;
  const composedStyle = !isMediaComponent && image ? (0,esm_extends/* default */.Z)({
    backgroundImage: `url("${image}")`
  }, style) : style;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    isMediaComponent,
    isImageComponent: IMAGE_COMPONENTS.indexOf(component) !== -1
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardMediaRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    as: component,
    role: !isMediaComponent && image ? 'img' : undefined,
    ref: ref,
    style: composedStyle,
    ownerState: ownerState,
    src: isMediaComponent ? image || src : undefined
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CardMedia_CardMedia = (CardMedia);

/***/ }),

/***/ 99690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12963);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23795);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);





function MyBreadcrumbs(_ref) {
  var routeList = _ref.routeList,
      inverted = _ref.inverted,
      t = _ref.t;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    "aria-label": "breadcrumb",
    separator: "\u203A",
    sx: {
      '.MuiBreadcrumbs-separator': {
        color: 'white'
      }
    },
    children: routeList.map(function (route) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        underline: "hover",
        color: inverted ? route.isActive ? '#DDDDDD' : 'white' : route.isActive ? 'text.primary' : "inherit",
        href: route.href,
        children: !!t ? t("home:".concat(route.label)) : route.label
      }, route.label);
    })
  });
}

/***/ }),

/***/ 8930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93946);
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94054);
/* harmony import */ var _mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33841);
/* harmony import */ var _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37058);
/* harmony import */ var _mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87109);
/* harmony import */ var _mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42761);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);











function MyInput(_ref) {
  var inputName = _ref.inputName,
      placeHolder = _ref.placeHolder,
      value = _ref.value,
      onChange = _ref.onChange,
      handleClick = _ref.handleClick,
      margin = _ref.margin,
      onKeyDown = _ref.onKeyDown;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    style: {
      marginTop: margin ? 10 : null
    },
    sx: {
      width: '25ch'
    },
    variant: "outlined",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      size: "small",
      style: {
        fontFamily: 'Montserrat',
        fontWeight: 500
      },
      htmlFor: inputName,
      children: placeHolder
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      size: "small",
      id: inputName,
      type: 'text',
      value: value,
      onChange: onChange,
      onKeyDown: function onKeyDown(ev) {
        if (ev.key === 'Enter') {
          // Do code here
          handleClick();
          ev.preventDefault();
        }
      },
      endAdornment: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        position: "end",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          "aria-label": "toggle password visibility",
          onClick: handleClick // onMouseDown={handleMouseDownPassword}
          ,
          edge: "end",
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        })
      }),
      label: placeHolder
    })]
  });
}

/***/ }),

/***/ 33260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10315);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30431);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90296);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80819);
/* harmony import */ var components_MyInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8930);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3580);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_utils_helper__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);









var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function (theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "row",
      padding: 0
    },
    table: {
      "&:last-child": {
        // backgroundColor: 'red',
        alignSelf: "flex-end !important",
        justifyContent: 'flex-end',
        display: 'flex'
      }
    }
  };
});
function MyList(props) {
  var classes = useStyles();
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var sort = props.sort,
      setSort = props.setSort,
      SORT_OPTIONS = props.SORT_OPTIONS,
      dataList = props.dataList,
      title = props.title,
      subTitle = props.subTitle,
      name = props.name,
      showAll = props.showAll,
      showSearchAndSort = props.showSearchAndSort,
      ItemComponent = props.itemComponent,
      baseUrl = props.baseUrl,
      t = props.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      searchInput = _useState[0],
      setSearchInput = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(dataList),
      localList = _useState2[0],
      setLocalList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isMobile = _useState3[0],
      setIsMobile = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var onChange = function onChange(e) {
    setSearchInput(e.target.value);
  };

  var onClickFind = function onClickFind() {
    var res = dataList.filter(function (item) {
      return item.name.toLowerCase().includes(searchInput.toLowerCase());
    });
    console.log('searching! : ', searchInput, res, res.length);
    setLocalList(res);
  };

  var handleSortChange = function handleSortChange(event) {
    setSort(event.target.value);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setLocalList(dataList);
    setLoaded(true);
  }, [dataList]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.checkMobile)());
    }
  }, [loaded]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
      style: {
        marginBottom: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      },
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("h1", {
        style: {
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 700,
          textDecoration: 'unset'
        },
        children: title
      }), showAll ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        href: "/brands/".concat(name),
        style: {
          alignSelf: 'flex-end',
          display: 'flex',
          textDecoration: 'none'
        },
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("h3", {
          style: {
            fontSize: 14,
            fontWeight: 400,
            color: '#7C7C7C',
            fontFamily: 'Montserrat'
          },
          children: !!t ? t('button_showall') : 'Show All'
        })
      }) : subTitle === undefined ? null : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("h3", {
        style: {
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 400,
          color: '#7C7C7C',
          fontFamily: 'Montserrat'
        },
        children: subTitle
      }), showSearchAndSort ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: "w-full h-full flex flex-row items-center justify-between",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          value: sort,
          onChange: handleSortChange,
          size: 'small',
          className: "w-52 text-sm bg-white",
          defaultValue: !!t ? t("home:".concat(SORT_OPTIONS[0].label)) : SORT_OPTIONS[0].label,
          children: SORT_OPTIONS.map(function (option) {
            return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              value: option,
              children: !!t ? t("home:".concat(option.label)) : option.label
            }, option.label);
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(components_MyInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          onChange: onChange,
          value: searchInput,
          handleClick: onClickFind,
          placeHolder: !!t ? t('home:findAnItem') : 'keyword',
          margin: false
        })]
      }) : null]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      className: "flex-grow",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        className: isMobile ? "flex grid grid-cols-1 items-center justify-center" : "grid grid-cols-4 gap-3",
        children: localList.map(function (item) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ItemComponent, {
            data: item,
            width: 262,
            margin: true,
            baseUrl: baseUrl === '/services/' ? "".concat(baseUrl, "listing") : baseUrl === '/products/' ? "".concat(baseUrl).concat(item.category.slug) : "".concat(baseUrl)
          }, item.name);
        })
      })
    })]
  });
}

/***/ }),

/***/ 25654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrandCard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83965);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44267);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36111);
/* harmony import */ var _mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91811);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);








function BrandCard(_ref) {
  var item = _ref.data,
      className = _ref.className,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? false : _ref$row,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
      margin = _ref.margin;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(item.followers),
      follower = _useState[0],
      setFollower = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(item.liked),
      liked = _useState2[0],
      setLiked = _useState2[1];

  var toggleLiked = function toggleLiked() {
    setLiked(!liked);
    setFollower(liked ? follower - 1 : follower + 1);
  };

  var handleImageError = function handleImageError(e) {
    e.target.onerror = null;
    e.target.src = "https://dummyimage.com/640x1:1/eeeeee/333333&text=".concat(item.name);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {// console.log('item: ', item)
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    onMouseEnter: onMouseEnter,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(row && 'flex', className, 'cursor-pointer'),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: "/brands/".concat(encodeURIComponent(item.slug), "/").concat(item.id),
      passHref: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "h-340 mb-5 cursor-pointer, shadow-md rounded overflow-hidden p-4",
        sx: {
          marginRight: margin === true ? 5 : 0 // maxWidth: 280,
          // margin: "0 auto",
          // padding: "0.1em",

        },
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
          style: {
            position: 'relative'
          },
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            component: "img",
            sx: {
              height: 262,
              padding: "1em 1em 0 1em",
              objectFit: 'contain'
            },
            image: item.logo,
            alt: encodeURIComponent(item.slug),
            onError: handleImageError
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
            onClick: function onClick() {
              return toggleLiked();
            },
            style: {
              position: "absolute",
              top: 10,
              left: "90%",
              transform: "translateX(-50%)",
              cursor: 'pointer'
            },
            children: liked === true ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            sx: {
              height: 50,
              fontSize: 16,
              fontWeight: 700,
              color: 'black',
              fontFamily: 'Montserrat'
            },
            children: item.name
          })
        })]
      })
    })
  });
}

/***/ }),

/***/ 92978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Products; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(75046);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87607);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var components_MyBreadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99690);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_MyList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33260);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41248);
/* harmony import */ var components_cards_BrandCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25654);
/* harmony import */ var lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77078);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57731);
/* harmony import */ var _data_config_json__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56513);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3580);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_utils_helper__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35944);



















var BRANDS_ROUTE = _data_config_json__WEBPACK_IMPORTED_MODULE_11__/* .brand.route */ .UQ.B;
var SORT_OPTIONS = _data_config_json__WEBPACK_IMPORTED_MODULE_11__/* .brand.sort */ .UQ.D;
var BREAD_ROUTE = [{
  label: 'Home',
  href: '/',
  isActive: false
}, {
  label: 'brands_product_brands',
  href: '/products',
  isActive: true
}];
var __N_SSP = true;
function Products(props) {
  var _page = props.page,
      _sort = props.sort;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var brands = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function (state) {
    return state.brand.brands;
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      localBrands = _useState[0],
      setLocalBrands = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(SORT_OPTIONS.find(function (s) {
    return s.sort.sortBy === _sort.sortBy && s.sort.order === _sort.order;
  }) || SORT_OPTIONS[0]),
      sort = _useState2[0],
      setSort = _useState2[1];

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    console.log('filtering product brand');
    setLocalBrands(brands.filter(function (item) {
      return item.bizType === 'PRODUCT';
    }));
  }, []);

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loaded = _useState3[0],
      setLoaded = _useState3[1];

  function initBrand() {
    return _initBrand.apply(this, arguments);
  }

  function _initBrand() {
    _initBrand = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var sort, page, filter;
      return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sort = {};
              page = 1;
              filter = {};
              _context.next = 5;
              return dispatch((0,lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_9__/* .getPaginatedBrandsThunk */ .XZ)({
                page: page,
                filter: filter,
                sort: sort
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _initBrand.apply(this, arguments);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    console.log('at products brands: ', brands.length);

    if (brands[0].name === 'Test') {
      initBrand();
    } else {
      setLoaded(true);
      setLocalBrands(brands.filter(function (item) {
        return item.bizType === 'PRODUCT';
      }));
    }

    return function () {
      console.log('clean up initBrand');
    };
  }, [brands]);

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,_utils_helper__WEBPACK_IMPORTED_MODULE_12__.checkMobile)());
    }
  }, [loaded]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
      style: {
        width: '100%',
        borderBottom: 'solid thin #DDDDDD'
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(components_MyBreadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          t: t,
          routeList: BREAD_ROUTE
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("nav", {
          className: isMobile ? (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)('flex', 'grow', 'shrink', 'min-w-0', 'overflow-scroll', 'mt-10') : (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)('flex', 'grow', 'shrink', 'min-w-0', 'overflow-hidden'),
          children: BRANDS_ROUTE.map(function (route) {
            return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: route.href,
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("a", {
                style: {
                  fontSize: 14,
                  fontWeight: router.pathname === route.href ? 600 : 400,
                  borderBottom: router.pathname === route.href ? 'solid 2px #108085' : 'unset'
                },
                className: isMobile ? (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)('font-normal', 'mr-7', 'last:mr-0', 'leading-5') : (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)('font-normal', 'mr-7', 'last:mr-0', 'leading-10'),
                children: t("home:".concat(route.label))
              })
            }, route.label);
          })
        })]
      })
    }), loaded ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(components_MyList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        t: t,
        itemComponent: components_cards_BrandCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
        dataList: localBrands,
        title: t('home:brands_product_brands'),
        sort: sort,
        setSort: setSort,
        SORT_OPTIONS: SORT_OPTIONS,
        showSearchAndSort: true
      })
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
      style: {
        marginTop: 50
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("span", {
        children: t('home:loading')
      })
    })]
  });
}

Products.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    children: page
  });
};

/***/ }),

/***/ 50600:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/products",
      function () {
        return __webpack_require__(92978);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,196,6694,7607,9774,2888,179], function() { return __webpack_exec__(50600); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);